import React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { authState } = useOktaAuth();
  const hasSimpleAuth = sessionStorage.getItem('simpleAuth') === 'true';
  
  if (!authState) {
    return null;
  }
  
  // Check if user is authenticated via Okta OR simple auth
  if (!authState.isAuthenticated && !hasSimpleAuth) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

export default PrivateRoute;
